// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"9fbede7f","285":"227fce88"}[chunkId] + ".chunk.js";
};